import type { Locale } from "@/lib/i18n";
import { pl, type WCardTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const wCardTranslations: Record<Locale, WCardTranslations> = {
  pl,
  en,
  de,
};

export type { WCardTranslations };
